export default __webpack_public_path__ + "static/media/arrow-down-white.043344c6.svg";